import axios from 'axios';
import { api } from '../../app/conf';

export const postLoginService = (provider, loginId, redirectUrl, errorRedirectUrl) => {
    const data = { loginId, redirectUrl };
    if (errorRedirectUrl) {
        data.errorRedirectUrl = errorRedirectUrl;
    }
    return axios({
        method: 'post',
        url: `${api}/v2/login/${provider}`,
        data
    });
};

export const getLoginStatusService = (provider, loginId) => axios({
    method: 'get',
    url: `${api}/v2/login/${provider}/status/${loginId}`,
});
